import React from 'react';
import '../styles/photoBooth.scss';
import photo1 from '../assets/photoBooth/photo1.jpg';
import photo2 from '../assets/photoBooth/photo2.jpg';
import photo3 from '../assets/photoBooth/photo3.jpg';
import photo4 from '../assets/photoBooth/photo4.jpg';
import photo5 from '../assets/photoBooth/photo5.jpg';
import photo6 from '../assets/photoBooth/photo6.jpg';
import photo7 from '../assets/photoBooth/photo7.jpg';
import photo8 from '../assets/photoBooth/photo8.jpg';

const PhotoBooth = () => {
  const photos = [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8];
  return (
    <div className="photoBooth" id="gallery">
      <div className="photoBooth__title">
        <h4 className="bold nextGeneration__text">Picture Yourself in Space</h4>
        <p className="copy">
          Visitors from around the world got a chance to beam their astronaut portraits onto Morgan
          Stanley’s Times Square billboard — broadcasting from the center of the Universe that the
          face of space travel is changing.
        </p>
      </div>
      <div className="photoBooth__gallery">
        {photos.map((photo, i) => {
          return <img src={photo} alt="" className="photoBooth__gallery__image" key={i} />;
        })}
      </div>
      <div className="photoBooth__button">
        <a
          className="linkButtons"
          rel="sponsored"
          target="_blank"
          href="https://sponsorcontent.cnn.com/interactive/morganstanley/creating-space/gallery/"
        >
          View All
        </a>
      </div>
    </div>
  );
};

export default PhotoBooth;
